import { CustomIconComponents } from './PasswordCheckList';

interface PasswordRuleProps {
    valid: boolean;
    iconComponents: CustomIconComponents;
    children: React.ReactNode;
}

const PasswordRule = ({ valid, iconComponents, children }: PasswordRuleProps) => {
    return (
        <li>
            <span className={`${valid ? 'icon-success' : 'icon'}`}>
                {valid ? iconComponents.validIcon : iconComponents.invalidIcon}
            </span>
            <span className="message">{children}</span>
        </li>
    );
};
export default PasswordRule;
